import React, { Component } from 'react'
import TInput from '../component/tinput'
import TButton from '../component/tbutton'
import TSection from '../component/tsection'
import { ruleRunner, run } from '../component/validation/rulerunner'
import { required, emailCheck } from '../component/validation/rules.js'
import { getParameterByName, postnummerCheck, createNewline } from '../component/functions'
import axios from 'axios';

import 'babel-polyfill'
let divbaground = {
    padding: '10px 20px',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat'
}
let dataId = document.getElementById("toyotaTilmeldingApp");
let checkDefault = getParameterByName("signup_campaign");
let campaginSource = getParameterByName("signup_source");
let defaultCampaign = "web formular: default";
let dataGetCampaign = dataId.getAttribute("data-signup-campaign");
let dataGetSource = dataId.getAttribute("data-signup-source");
let campaingDataLoaded = false;

const fieldValidations = [
    ruleRunner('email', 'Email', emailCheck),
    ruleRunner('fornavn', 'Fornavn', required),
    ruleRunner('efternavn', 'Efternavn', required),
    ruleRunner('postnummer', 'Postnummer', required),
    ruleRunner('eventskonkurrencer', 'Events og konkurrencer', required)
]
const Konkurrence = class Konkurrence extends Component {
    state = {
        form: 'tilmeld',
        showErrors: false,
        validationErrors: {},
        disctrictId: '',
        posts: [],
        loading: true,
        competition: false,
        showTopheaderShow: false,
        error: null,
        inputStart: false
    }

    inputChange = async t => {
        // Trigger datalayer on form start
        if (!this.state.inputStart) {
            this.setState({ inputStart: true })
            if (window.tngaDataLayer) {
                window.tngaDataLayer.event = {
                    name: "formevent", componentName: "newsletter", componentGroup: "forms", action: "form-step",
                    label: "form-fill-start"
                };
                window.tngaDataLayer.form = {
                    name: "lead-newsletter", step: "form-fill-start", conversion: "0"
                };
                window.dataLayer.push({ 'event': 'formevent' });
            }
        }

        const inputName = t.target.name
        let newState = {
            ...this.state,
            [inputName]: t.target.value,
            inputStart: true
        }
        newState.validationErrors = await run(newState, fieldValidations)
        this.setState(newState, () => {
            if (this.state.postnummer && this.state.postnummer.length > 0) {
                let pcheck = postnummerCheck(this.state.postnummer)
                pcheck.then(data => {
                    if (data === false) {
                        let newState = {
                            ...this.state,
                            validationErrors: {
                                ...this.state.validationErrors,
                                postnummer: 'Postnummer findes ikke i database'
                            }
                        }
                        this.setState(newState)
                    } else {
                        if (
                            this.state.validationErrors &&
                            this.state.validationErrors.postnummer
                        )
                            delete this.state.validationErrors.postnummer
                        this.setState({ disctrictId: data })
                    }
                })
            }
        })
    }
    submitForm = e => {
        e.preventDefault()
        // recheck postnummer
        if (
            this.state &&
            this.state.postnummer &&
            this.state.postnummer.length > 0
        ) {
            let pcheck = postnummerCheck(this.state.postnummer)
            pcheck.then(data => {
                if (data === false) {
                    let newState = {
                        ...this.state,
                        validationErrors: {
                            ...this.state.validationErrors,
                            postnummer: 'Postnummer findes ikke i database'
                        }
                    }
                    this.setState(newState, () => this.submitData())
                } else {
                    let newState = { ...this.state }
                    if (
                        newState.validationErrors &&
                        newState.validationErrors.postnummer
                    ) {
                        delete newState.validationErrors.postnummer
                        this.setState({
                            newState
                        })
                    }
                    this.submitData()
                }
            })
        } else {
            this.submitData()
        }
    }
    checkAffiliate = () => {
        let external_url = this.state.loadedCampaignData.mainSettings[0].external_url;
        let step = getParameterByName('Step');
        let recipient_id = getParameterByName('recipient_id');
        let external_id = getParameterByName('external_id');
        let query = '&transaction_id=' + external_id + '&adv_sub=' + recipient_id;
        let activation_url = external_url + query;

        if (external_url && external_id !== "" && external_id !== " " && step === '3') {
            fetch(activation_url, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "no-cors", // no-cors, cors, *same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            });
        }
    }


    submitAffiliate = () => {
        let url = "https://news.toyota.dk/pub/rf?_ri_=X0Gzc2X%3DAQpglLjHJlCQG2N46RSULtgy7dB8lP6sntMHtU8unjf6VwjpnpgHlpgneHmgJoXX0Gzc2X%3DAQpglLjHJlCQGwzgHWFzbTNzct7bJn8pnHRJdKzaazcWkCczb7&_ei_=EWi77qCa843bNHMlM3SQhR4&_di_=n6ace66pjghqe2p1c67agbne6n6c906e31tomc9ac88e0gm59vmg";
        let email = getParameterByName('EMAIL_ADDRESS_');
        let campaign = getParameterByName('signup_campaign');
        let query = `&EMAIL_ADDRESS_=${email}&SIGNUP_CAMPAIGN=${campaign}`;
        let btnUrl = this.state.loadedCampaignData.stepThree[0].buttonUrl;

        if (this.state.competition !== 'Y') {
            window.open(btnUrl, '_blank');
        } else if (this.state.competition === 'Y') {
            window.open(url + query, '_blank');
        }
    }
    submitData = () => {
        if (this.state.competition !== "Y") { this.setState({ nyhedsbrev: 1 }) };
        if (
            Object.keys(this.state.validationErrors).length === 0 &&
            this.state.email &&
            this.state.fornavn &&
            this.state.efternavn &&
            this.state.postnummer &&
            this.state.eventskonkurrencer &&
            this.state.nyhedsbrev
        ) {
            // submit to responsys
            // https://www.toyota.dk/forms/e-newsletter?campaign=Facebook%3A%20permission_Maj_Burst1_mailliste
            // let campaignText = 'web formular: GDPR_lykkehjul'
            //let campaignText = 'web formular: Beach_volley'
            let campaignText = 'web formular: default';
            let signupSource = 'toyota.dk: default';
            let external_id = getParameterByName('external_id') === null ? "" : "&external_id=" + getParameterByName('external_id');
            let external_campaign = getParameterByName('external_campaign') === null ? "" : "&external_campaign=" + getParameterByName('external_campaign');
            /*if(this.state.campaingDataLoaded.dataUse){
                campaignText = dataCampaign
                signupSource = dataSource
            }*/
            if (dataGetSource !== null) {
                signupSource = dataGetSource;
            }
            if (dataGetSource !== null) {
                campaignText = dataGetCampaign;
            }

            if (campaginSource !== null) {
                signupSource = campaginSource;
            }
            if (checkDefault !== null) {
                campaignText = checkDefault;
            }
            if (this.state.loadedCampaignData.campaignName === "vind_weekend2019_verizon") {
                const script = document.createElement("script");
                var t = document.createTextNode("window.dotq = window.dotq || [];window.dotq.push({projectId:'10000',properties:{pixelId:'10081994',qstrings:{'et':'custom','ec':'competition'}}});");
                script.appendChild(t);
                document.body.appendChild(script);
            }

            if (this.state.loadedCampaignData.campaignName === "julekalender2019_aff_verizon") {
                const script = document.createElement("script");
                var t = document.createTextNode("window.dotq = window.dotq || [];window.dotq.push({projectId:'10000',properties:{pixelId:'10081994',qstrings:{'et':'custom','ea':'julekalender_click'}}});");
                script.appendChild(t);
                document.body.appendChild(script);
            }

            if (this.state.loadedCampaignData.campaignName === "aygo_sommer2019_aff") {
                const script = document.createElement("script");
                var t = document.createTextNode("window.dotq = window.dotq || [];window.dotq.push({projectId:'10000',properties:{pixelId:'10081994',qstrings:{'et':'custom','ec':'formsubmit'}}});");
                script.appendChild(t);
                document.body.appendChild(script);
            }
            let url = 'https://news.toyota.dk/pub/rf?_ri_=X0Gzc2X=AQpglLjHJlCQGrzah6eyzaOzecJKwEArawnjKwXc6MnzcXDFVwjpnpgHlpgneHmgJoXX0Gzc2X=AQpglLjHJlCQGnj6P0tvcUoUHLWIzfbs2qfyIvezbfMLDa&_ei_=EtKRh-XMe64J-mhCNQecGSQ&_di_=h2fjtsithfpk8bgaphspr6o0l2r9ueu5890p5locf3jk0le9dmug';
            let query = `EMAIL_ADDRESS_=${this.state.email}&FIRSTNAME=${this.state.fornavn
                }&LASTNAME=${this.state.efternavn
                }&PERMISSION_REMINDERS=&PERMISSION_NEWS_AND_OFFERS=${this.state.nyhedsbrev
                }&PERMISSION_SURVEY=&PERMISSION_EVENT_COMPETITION=${this.state.eventskonkurrencer
                }&SIGNUP_SOURCE=${signupSource}&SIGNUP_PERMISSION_VERSION=2022-01&SIGNUP_CAMPAIGN=${campaignText}&signup_id=${Date.now()}&SIGNUP_TYPE=custom&POSTAL_CODE_=${this.state.postnummer
                }&DISTRICT=${this.state.disctrictId}
            ${external_id}
            ${external_campaign}`;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: query
            }).then(this.setState({ form: 'tak' }, () => {
                //window.scrollTo({top: dataId.offsetTop, behavior: 'smooth'})
                if (window.tngaDataLayer) {
                    window.tngaDataLayer.event = {
                        name: "formevent",
                        componentName: "newsletter",
                        componentGroup: "forms",
                        action: "form-step",
                        label: "form-submit"
                    };
                    window.tngaDataLayer.form = {
                        name: "lead-newsletter", step: "form-submit", conversion: "1"
                    };
                    window.dataLayer.push({ 'event': 'formevent' });
                }
                document.getElementById('toyotaTilmeldingApp').scrollIntoView({
                    behavior: 'smooth'
                });
            }))
        } else {
            let valErr = {}
            if (!this.state.email) valErr.email = 'email skal udfyldes'
            if (!this.state.fornavn) valErr.fornavn = 'fornavn skal udfyldes'
            if (!this.state.efternavn)
                valErr.efternavn = 'efternavn skal udfyldes'
            if (!this.state.postnummer)
                valErr.postnummer = 'efternavn skal udfyldes'
            if (!this.state.eventskonkurrencer)
                valErr.eventskonkurrencer = 'Events og konkurrencer skal udfyldes'
            if (!this.state.nyhedsbrev)
                valErr.nyhedsbrev = 'Nyhedsbrev og konkurrencer skal udfyldes'
            if (
                this.state.validationErrors &&
                this.state.validationErrors.postnummer
            )
                valErr.postnummer = 'Postnummer findes ikke i database'
            this.setState({ showErrors: true, validationErrors: valErr })
        }
    }
    checkCampaign(checkCampaignName) {
        this.state.campaignData.campaigns.map((campaigns, i) => {
            if (checkCampaignName === campaigns.campaignName) {
                this.setState({ loadedCampaignData: campaigns })

                if (campaigns.stepOne[0].bodyText.length > 0) {
                    this.setState({ showTopheaderShow: true })
                }
                if (campaigns.stepOne[0].headline.length > 0) {
                    this.setState({ showTopheaderShow: true })
                }
                /**/
                if (campaigns.stepOne[0].topImage.length > 0) {
                    this.setState({ showTopheaderShow: true })
                }/**/
                this.setState({ competition: campaigns.mainSettings[0].competition })
                divbaground = {
                    background: campaigns.mainSettings[0].backgroundColor,
                    backgroundImage: 'url(' + campaigns.mainSettings[0].backgroundImage + ')',
                    padding: '10px 20px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat'

                }
                campaingDataLoaded = true;

            }
            return campaigns
        })
    }
    componentWillMount() {

        if (getParameterByName('Step') === '3') {
            this.setState({ form: 'step-3' })
        }
        if (getParameterByName('Step') === '2') {

            this.setState({ form: 'tak' })
        }
    }

    componentDidMount() {

        if (this.state.form === "tak") {
            const script = document.createElement("script");
            var t = document.createTextNode("window.dotq = window.dotq || [];window.dotq.push({projectId:'10000',properties:{pixelId:'10081994',qstrings:{'et':'custom','ec':'formsubmit'}}});");
            script.appendChild(t);
            document.body.appendChild(script);

        }
        axios.get(`//webapi.toyota.dk/projects/Standard_Tilmelding/json/campaign.json?ts=` + new Date())
            .then(res => {

                this.setState({
                    campaignData: res.data,
                    error: null
                });



                if (checkDefault !== null && checkDefault !== "" & checkDefault !== " ") {
                    this.checkCampaign(checkDefault);
                }
                if (campaingDataLoaded === false && dataGetSource !== undefined && dataGetCampaign !== undefined) {
                    this.checkCampaign(dataGetCampaign);
                }
                if (campaingDataLoaded === false) {
                    this.checkCampaign(defaultCampaign);
                }
                this.setState({
                    loading: false
                });
                if (this.state.loadedCampaignData.campaignName === "aygo_sommer2019_aff") {
                    const script = document.createElement("script");
                    var t = document.createTextNode("type='application/javascript'>(function(w,d,t,r,u){w[u]=w[u]||[];w[u].push({'projectId':'10000','properties':{'pixelId':'10081994'}});var s=d.createElement(t);s.src=r;s.async=true;s.onload=s.onreadystatechange=function(){var y,rs=this.readyState,c=w[u];if(rs&&rs!='complete'&&rs!='loaded'){return}try{y=YAHOO.ywa.I13N.fireBeacon;w[u]=[];w[u].push=function(p){y([p])};y(c)}catch(e){}};var scr=d.getElementsByTagName(t)[0],par=scr.parentNode;par.insertBefore(s,scr)})(window,document,'script','https://s.yimg.com/wi/ytc.js','dotq');");
                    script.appendChild(t);
                    document.body.appendChild(script);
                }
                this.checkAffiliate();
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    error: err
                });
            });
    }
    renderPosts() {
        return (
            <div className={`${this.state.loading ? 'hide' : 'show'}`}>
                <form
                    onSubmit={this.submitForm}
                    className={`${this.state.form === 'tilmeld' && 'show'}`}
                >
                    <div className="up-to-date">
                        {this.state.loadedCampaignData && (
                            <div className={" topHeaderInfomartion " + (this.state.showTopheaderShow ? 'show' : 'hidden')}>
                                {this.state.loadedCampaignData.stepOne[0].topImage && (<img src={this.state.loadedCampaignData.stepOne[0].topImage} alt="topImage" className="topImage" />)}
                                {this.state.loadedCampaignData.stepOne[0].headline && (<h2 className="headline first"> {this.state.loadedCampaignData.stepOne[0].headline} </h2>)}
                                <div className="bodyText first" >
                                    {this.state.loadedCampaignData.stepOne[0].bodyText && (<div>{createNewline(this.state.loadedCampaignData.stepOne[0].bodyText)}</div>)}
                                    {this.state.loadedCampaignData.stepOne[0].bodyLinkText && (<div className="bodyLink"> <a href={this.state.loadedCampaignData.stepOne[0].bodyLinkURL} target="_blank"> {createNewline(this.state.loadedCampaignData.stepOne[0].bodyLinkText)}  </a> </div>)}
                                    <br />
                                    {this.state.loadedCampaignData.stepOne[0].legalText && (<div className="legalText">{createNewline(this.state.loadedCampaignData.stepOne[0].legalText)}</div>)}

                                </div>
                            </div>
                        )}


                        <TInput
                            name="email"
                            type="email"
                            onChange={this.inputChange}
                            placeholder="E-mailadresse (påkrævet)"
                            validations={[required]}
                            valid={
                                this.state.showErrors &&
                                    this.state.validationErrors['email']
                                    ? 'false'
                                    : undefined
                            }
                        />
                        <TInput
                            onChange={this.inputChange}
                            name="fornavn"
                            placeholder="Fornavn (påkrævet)"
                            valid={
                                this.state.showErrors &&
                                    this.state.validationErrors['fornavn']
                                    ? 'false'
                                    : undefined
                            }
                        />
                        <TInput
                            onChange={this.inputChange}
                            name="efternavn"
                            placeholder="Efternavn (påkrævet)"
                            valid={
                                this.state.showErrors &&
                                    this.state.validationErrors['efternavn']
                                    ? 'false'
                                    : undefined
                            }
                        />
                        <TInput
                            onChange={this.inputChange}
                            name="postnummer"
                            placeholder="Postnummer (påkrævet)"
                            type="number"
                            valid={
                                this.state.showErrors &&
                                    this.state.validationErrors['postnummer']
                                    ? 'false'
                                    : undefined
                            }
                        />
                        <div>
                            <br />
                            Markedsføringsmæssigt vil dit samtykke kun blive brugt til den kommunikation, du selv vælger nedenfor og kun fra de dele af Toyota organisationen, du i forvejen har en relation til. Dit samtykke vil derfor ikke blive brugt til overdreven markedsføring.
                            <br />
                            <br />

                            Du afgiver samtykke til, at Toyota organisationen (37) og dens samarbejdspartnere <i className="hstooltip icon icon-info-sign" >
                                <span className="hstooltiptext" >
                                    "Toyota organisationen" omfatter pt. autoriserede Toyota forhandlere og Toyota reparatører i Danmark/Færøerne (i alt 33 juridiske enheder) (link: <a href="https://www.toyota.dk/toyota-forhandlere" rel="noopener noreferrer" target="_blank">https://www.toyota.dk/toyota-forhandlere</a>), Toyota Danmark A/S, Toyota Motor Europe nv/sa., Toyota Financial Services Danmark A/S og Toyota Insurance Management, filial af Toyota Insurance Management SE, Germany. Toyota forhandlere og reparatører er selvstændige juridiske enheder, som samtykket også gælder i forhold til efter evt. ophør som Toyota forhandler eller reparatør. Toyotas "samarbejdspartnere" omfatter pt. Gjensidige Forsikring, dansk filial af Gjensidige Forsikring ASA, Norge.
                                </span> </i> må kontakte dig elektronisk*, pr. brev og pr. telefon samt behandle, herunder indbyrdes videregive, dine personoplysninger <i className="hstooltip icon icon-info-sign" >
                                <span className="hstooltiptext" >
                                    f.eks. kontaktoplysninger (navn, e-mail, adresse, telefonnummer mv.), oplysninger om din bil (herunder billeder og video af bilen) og din brug af hhv. bil samt fysiske og digitale tjenester, der udbydes af Toyota organisationen (f.eks. oplysninger fra forhandler, om værkstedsbesøg, via cookies fra hjemmesider, feedback vedrørende Toyota-organisationen mv.).
                                </span> </i> i relation til de tilvalgte bil- og mobilitetsrelaterede tjenester nævnt nedenfor. Behandlingen sker i overensstemmelse med Toyota's <a href="https://www.toyota.dk/legal/privatlivspolitik" target="_blank">privatlivspolitik</a>.
                            <br />
                            <br />

                            Du kan altid kontakte Toyota organisationen vedrørende dine data og dit samtykke. Du kan altid tilbagekalde dit samtykke ved at kontakte Toyota organisationen, eller den forretning, hvor du har afgivet samtykke, enten pr. e-mail, telefon eller ved personligt fremmøde.
                            <br />
                            <br />

                            Toyota organisationen må bruge  samtykket til at spørge, om du ønsker at opdatere dit samtykke mht. nye samarbejdspartnere, produkter eller kontaktformer.
                            <br /><br />
                            <i>* f.eks. e-mails, notifikationer, push-beskeder, sms/mms, Facebook, Instagram, LinkedIn.</i>
                        </div>
                        {this.state.competition === "Y" ?
                            <TSection name="nyhedsbrev"
                                onChange={this.inputChange}
                                valid={this.state.showErrors &&
                                    this.state.validationErrors['nyhedsbrev'] ? 'false' : undefined}
                                inputtwodisabled="disabled">
                                Ønsker du at modtage tilbud og nyheder&nbsp;
                                <i className="hstooltip icon icon-info-sign">
                                    <span className="hstooltiptext">
                                        f.eks. om værkstedsydelser, biler, tilbehør, leasing, finansiering, forsikring, vejhjælp og andre bil- og mobilitetsrelaterede produkter og services samt historier om Toyota og din lokale forhandler.
                                    </span>
                                </i> &nbsp;fra Toyota
                            </TSection>
                            :
                            <TSection name="nyhedsbrev"
                                noInput="true">
                                Ved tilmelding til Toyotas nyhedsbrev accepterer du at modtage produkttilbud og nyheder&nbsp;
                                <i className="hstooltip icon icon-info-sign">
                                    <span className="hstooltiptext">
                                        f.eks. om værkstedsydelser, biler, tilbehør, leasing, finansiering, forsikring, vejhjælp og andre bil- og mobilitetsrelaterede produkter og services samt historier om Toyota og din lokale forhandler.
                                    </span>
                                </i> &nbsp;fra Toyota
                            </TSection>
                        }
                        <TSection
                            name="eventskonkurrencer"
                            onChange={this.inputChange}
                            valid={
                                this.state.showErrors &&
                                    this.state.validationErrors[
                                    'eventskonkurrencer'
                                    ]
                                    ? 'false'
                                    : undefined
                            }
                        >

                            {this.state.competition === "Y" ?
                                `Ønsker du også at modtage information om fremtidige events og konkurrencer?` :
                                `Ønsker du også at modtage information om events og konkurrencer?`
                            }&nbsp;
                            <i className="hstooltip icon icon-info-sign">
                                <span className="hstooltiptext">
                                    f.eks. så du kan blive inviteret til VIP-arrangementer, åbent hus og deltage i spændende konkurrencer med eksklusive præmier.
                                </span>
                            </i>
                        </TSection>




                        <div className="center margin">
                            <TButton
                                value="TILMELD"
                                onClick={this.submitForm}
                            />
                        </div>
                    </div>
                </form>
                <form className={`${this.state.form === 'tak' && 'show'}`}>
                    <div className="up-to-date">
                        <div className="center">
                            {this.state.loadedCampaignData && (
                                <div>
                                    {this.state.loadedCampaignData.stepTwo[0].topImage && (<img src={this.state.loadedCampaignData.stepTwo[0].topImage} alt="topImage" className="topImage" />)}
                                    {this.state.loadedCampaignData.stepTwo[0].headline && (<h2 className="headline"> {this.state.loadedCampaignData.stepTwo[0].headline} </h2>)}
                                    {this.state.loadedCampaignData.stepTwo[0].bodyText && (<div className="bodyText"> {createNewline(this.state.loadedCampaignData.stepTwo[0].bodyText)} </div>)}
                                </div>
                            )}
                        </div>
                    </div>
                </form>
                <form
                    className={`${this.state.form === 'step-3' && 'show'}`}
                    onSubmit={e => {
                        e.preventDefault()
                    }}
                >
                    <div className="up-to-date">

                        {this.state.loadedCampaignData && (
                            <div>
                                <div className="center">
                                    {this.state.loadedCampaignData.stepThree[0].topImage && (<img src={this.state.loadedCampaignData.stepTwo[0].topImage} alt="topImage" className="topImage" />)}
                                    {this.state.loadedCampaignData.stepThree[0].topImage && (<h2 className="headline"> {this.state.loadedCampaignData.stepThree[0].headline} </h2>)}
                                    {this.state.loadedCampaignData.stepThree[0].topImage && (<div className="bodyText"> {createNewline(this.state.loadedCampaignData.stepThree[0].bodyText)} </div>)}
                                </div>
                                {this.state.loadedCampaignData.stepThree[0].buttonText && (<div className="center">
                                    <TButton
                                        value={this.state.loadedCampaignData.stepThree[0].buttonText}
                                        onClick={this.submitAffiliate}
                                    />
                                </div>)}
                            </div>
                        )}
                    </div>
                </form>

            </div>)
    }
    renderLoading() {
        return (<div className="lds-css ng-scope"><div className="ringPosotion"><div className="lds-dual-ring"><div></div></div></div></div>);
    }
    render() {

        return (
            <div style={divbaground} id="styledbackground">
                {this.state.loading ?
                    this.renderLoading()
                    : this.renderPosts()}
            </div>
        )

    }
}

export default Konkurrence



// WEBPACK FOOTER //
// ./src/feature/konkurrence.js